import { salesforceAuthClient } from 'integrations/salesforce/infras/rest';
import 'url-search-params-polyfill';

import { Request } from 'express';
import { ViewerItem } from 'presentations/api/schema/user';

export const salesforceAuthUrl = (req: Request, redirectPath: string) => {
  const state = req.protocol + '://' + req.get('host') + redirectPath;
  const clientId = process.env['SALESFORCE_CONSUMER_KEY'];
  const redirectUri = process.env['SALESFORCE_REDIRECT_URL']!;
  const scope = ['refresh_token', 'api'].join(' ');
  return (
    `https://login.salesforce.com/services/oauth2/authorize` +
    `?client_id=${clientId}` +
    `&response_type=code` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&scope=${encodeURIComponent(scope)}` +
    `&state=${state}`
  );
};

export const revokeToken = async (accessToken: string) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  try {
    const result = await salesforceAuthClient.get(
      `/services/oauth2/revoke?token=${accessToken}`,
      { headers },
    );

    return result.data;
  } catch (error) {
    console.debug(error.response.data);
    console.warn('oauth/token revoke error.');
    return;
  }
};

export const isAvailableSalesforce = (viewer: ViewerItem | null): boolean => {
  const environmentVariable = process.env['SALESFORCE_PILOT_TEAM_IDS'];
  if (environmentVariable) {
    if (!viewer || !viewer.team) return false;
    const teamId = viewer.team.id!;
    const salesforcePilitTeamIds = environmentVariable.split(',');

    if (salesforcePilitTeamIds.length > 0 && viewer.team) {
      return salesforcePilitTeamIds.some((id) => Number(id) === teamId);
    }
  }

  return true;
};
